import React, { useState } from "react";
import Layout from "../layout/Layout";
import firstImage from "../assets/firstImage.png";

const BLOG_POSTS = [
  {
    id: 1,
    title: "Understanding Dog Body Language",
    date: "July 10, 2026",
    excerpt: "Dogs communicate in a variety of subtle ways. Learn how to read their ears, tail, and posture to understand their feelings.",
    content: "Dogs don't speak human language, but they communicate constantly. By paying close attention to their tail wags, ear positions, and posture, you can understand if your dog is relaxed, anxious, or feeling playful.\n\nFor example, a high and stiff wagging tail often indicates alertness or agitation, rather than happiness. On the other hand, a loose, low-to-mid height wag usually signals a happy, relaxed state. Similarly, ears pinned flat back against the head suggest fear or submissiveness, while forward ears show curiosity and focus.\n\nLearning to decipher these micro-signals can significantly strengthen the bond you share with your companion and prevent stressful situations before they escalate."
  },
  {
    id: 2,
    title: "The Perfect Diet for Your Feline Friend",
    date: "June 28, 2026",
    excerpt: "Cats are obligate carnivores. Discover the critical nutrients they need and how to balance wet vs dry food options.",
    content: "Unlike dogs, cats are obligate carnivores, meaning their bodies are biologically designed to process nutrients from animal tissues. A healthy feline diet requires high levels of animal protein, specific amino acids like taurine, and proper hydration.\n\nWhile dry kibble is convenient, wet food is often recommended by vets to help meet your cat's moisture needs. Cats naturally have a low thirst drive and obtain most of their hydration from their food. A lack of moisture can lead to urinary tract issues over time.\n\nConsulting with your veterinarian to balance wet and dry options based on your cat's age and activity level is the best way to ensure a long, healthy life."
  },
  {
    id: 3,
    title: "Creating a Pet-Friendly Home Environment",
    date: "May 15, 2026",
    excerpt: "Designing a safe, comfortable, and stimulating environment to keep your indoor pets happy and healthy.",
    content: "Your home is your pet's entire world. Creating a pet-friendly environment goes beyond laying out a bed and food bowls. It involves thinking about vertical space for cats, safe zones for dogs, and sensory stimulation.\n\nFor cats, verticality is key. Installing cat shelves or keeping window sills clear allows them to observe their territory from a safe height. For dogs, a dedicated quiet corner away from heavy foot traffic helps them feel secure when they need rest.\n\nAdditionally, be mindful of indoor plants—many common houseplants like lilies and devil's ivy are highly toxic to cats and dogs. Always verify plant safety before bringing greenery home."
  }
];

const Blog = () => {
  const [selectedPost, setSelectedPost] = useState(null);

  return (
    <Layout>
      <div className=" flex h-[92vh] px-10">
        {/* left content */}
        <div className=" lg:w-1/2 w-full mt-24 z-10 pb-10 overflow-y-auto max-h-[80vh] pr-4">
          <div className=" max-w-[80%]">
            {selectedPost ? (
              <div>
                <button
                  onClick={() => setSelectedPost(null)}
                  className=" mb-6 text-sm font-semibold text-black bg-[#F5D8CE] px-4 py-2 rounded-xl hover:bg-opacity-80 transition-colors"
                >
                  ← Back to Journal
                </button>
                <span className=" text-sm text-[#6D6D6D] block mb-2">{selectedPost.date}</span>
                <h1 className=" text-3xl font-bold text-[#3E3E3E] mb-6">
                  {selectedPost.title}
                </h1>
                <div className=" text-[#6D6D6D] text-[16px] leading-relaxed whitespace-pre-line">
                  {selectedPost.content}
                </div>
              </div>
            ) : (
              <div>
                <h1 className=" text-4xl font-bold text-[#3E3E3E] mb-2">
                  Pet Journal
                </h1>
                <p className=" text-[#6D6D6D] text-[16px] mb-10">
                  Insights, advice, and stories from our team of pet care experts.
                </p>

                <div className=" flex flex-col gap-8">
                  {BLOG_POSTS.map((post) => (
                    <div
                      key={post.id}
                      onClick={() => setSelectedPost(post)}
                      className=" border-b border-[#F5D8CE] pb-8 cursor-pointer group"
                    >
                      <span className=" text-sm text-[#6D6D6D]">{post.date}</span>
                      <h2 className=" text-2xl font-bold text-[#3E3E3E] mt-1 group-hover:text-black transition-colors">
                        {post.title}
                      </h2>
                      <p className=" text-[#6D6D6D] text-[15px] mt-2 line-clamp-2">
                        {post.excerpt}
                      </p>
                      <span className=" inline-block mt-4 text-sm font-semibold text-black group-hover:underline">
                        Read Article →
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Pane (Static Image to support the white Navbar links) */}
        <div className=" lg:w-1/2 w-full h-full absolute top-0 right-0">
          <div
            className=" h-full"
            style={{
              backgroundImage: `url(${firstImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        </div>
      </div>
    </Layout>
  );
};

export default Blog;